<script setup lang="ts">
import VText from "@magnit/core/src/components/VText/VText.vue";

defineProps<{
  hideLabel?: boolean;
  blurred?: boolean;
  thumbnail?: boolean;
}>();
const emit = defineEmits<{
  click: [];
}>();
</script>

<template>
  <template v-if="blurred">
    <div class="unit-catalog-adult-image" @click="emit('click')">
      <div
        class="unit-catalog-adult-image__img"
        :class="{ 'unit-catalog-adult-image__img-thumbnail': thumbnail }"
      >
        <slot />
      </div>
      <div v-if="!hideLabel" class="unit-catalog-adult-image__label">
        <VText
          class="unit-catalog-adult-image__title"
          :font="{ xs: 'caption-large-accent-low', l: 'body-small-accent-low' }"
          color="secondary"
        >
          товар 18+
        </VText>
      </div>
    </div>
  </template>
  <template v-else>
    <slot />
  </template>
</template>

<style lang="postcss" scoped>
.unit-catalog-adult-image {
  cursor: pointer;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &__title {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  &__img {
    filter: blur(var(--pl-unit-x10));
    z-index: 0;
    object-fit: contain;
    object-position: center;
    pointer-events: none;

    &-thumbnail {
      filter: blur(var(--pl-unit-x2));
    }
  }

  &__label {
    display: inline-flex;
    align-items: center;
    position: absolute;
    z-index: 2;
    border-radius: var(--pl-unit-x4);
    padding: 0 6px;
    background: var(--pl-surface-primary-default);
    max-width: 100%;
    height: 22px;

    @media (--pl-viewport-from-l) {
      padding: 0 var(--pl-unit-x2) 0 6px;
      height: 28px;
    }
  }
}
</style>
